import { jsx as _jsx } from "react/jsx-runtime";
import { Edit as EditIcon, Send as SendIcon, Uploads as UploadsIcon } from "@air/next-icons";
export const CONTENT_COLLECTION_INSTRUCTIONS = [
    {
        icon: /*#__PURE__*/ _jsx(UploadsIcon, {
            className: "size-4"
        }),
        label: "1. Upload items",
        description: "Select the files you want to submit."
    },
    {
        icon: /*#__PURE__*/ _jsx(EditIcon, {
            className: "size-4"
        }),
        label: "2. Fill in fields",
        description: "Provide any required fields once for all items or set them individually per upload."
    },
    {
        icon: /*#__PURE__*/ _jsx(SendIcon, {
            className: "size-4"
        }),
        label: "3. Submit",
        description: "Review your items and submit when ready."
    }
];
